import * as React from 'react';
import type { SupportedWixLocales } from 'wix-design-systems-locale-utils';

export type CounterBadgeSize = 'medium' | 'small';

export type CounterBadgeSkin =
  | 'general'
  | 'standard'
  | 'danger'
  | 'warning'
  | 'urgent'
  | 'success'
  | 'neutralStandard'
  | 'light';

export interface CounterBadgeProps {
  /** Any element to be rendered inside */
  children?: React.ReactNode;
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** A css class to be applied to the component's root element */
  className?: string;
  /** Sets locale and formats the number according to it */
  locale?: SupportedWixLocales;
  /** The component's look and feel */
  skin?: CounterBadgeSkin;
  /** The component's size. Can be small or medium */
  size?: CounterBadgeSize;
  /** Makes the card have a box-shadow style */
  showShadow?: boolean;
  /** Control whether values greater than 99 should be truncated */
  truncate?: boolean;
}
